module.exports = __webpack_public_path__ + "e915d23c5bb177e3e97fc7e01b0fb7fe.svg";